import { useState } from 'react'
import { Button } from './Button'

interface AcceptTermsFormProps {
  onAccept: () => void
}

export const AcceptTermsForm: React.FC<AcceptTermsFormProps> = ({ onAccept }) => {
  const [checked, setChecked] = useState(false)

  return (
    <div>
      <p className="text-sm text-gray-600 mb-4">
        Before you can start taking clients through Conveyo.One, please review and accept our terms.
      </p>

      <div className="max-h-48 overflow-y-auto text-sm text-gray-600 border border-gray-200 rounded-lg p-4 mb-4 space-y-2">
        <p>
          By using Conveyo.One you agree to keep client and payment data confidential, use the platform only
          for lawful conveyancing activity, and remain responsible for the accuracy of information you submit
          on behalf of your firm and its clients.
        </p>
        <p>
          Payments are processed by our payments partner, Pinch, under its own terms — setting up your merchant
          account in the next step means you also accept Pinch&rsquo;s merchant terms of service.
        </p>
      </div>

      <label className="flex items-start gap-2 mb-4 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="mt-1"
        />
        <span className="text-sm text-gray-700">I have read and accept the Terms and Conditions.</span>
      </label>

      <Button type="button" onClick={onAccept} disabled={!checked}>
        Continue
      </Button>
    </div>
  )
}
